import type { PluginFunc } from 'dayjs';

import WeekOfMonth from './WeekOfMonth';
import type { ToISOWeekOfMonth } from './WeekOfMonth';

/**
 * @see {@link https://velog.io/@newwwbi/%ED%83%80%EC%9E%85%EC%8A%A4%ED%81%AC%EB%A6%BD%ED%8A%B8%EC%97%90%EC%84%9C-Dayjs-%ED%94%8C%EB%9F%AC%EA%B7%B8%EC%9D%B8-%EB%A7%8C%EB%93%9C%EB%8A%94-%EB%B0%A9%EB%B2%95}
 */
declare module 'dayjs' {
  /**
   * IOS-8601 표준에 맞게 날짜가 속한 주가 그 달의 몇 번째 주 인지 연, 월, 주를 반환.
   *
   * @example
   * ```
   * dayjs.toISOWeekOfMonth()// => e.g. { year: 2022, month: 12, week: 2 }
   * dayjs.toISOWeekOfMonth('2022-10-01')// { year: 2022, month: 9, week: 5 }
   * dayjs.toISOWeekOfMonth(dayjs('2022-06-30'))) // { year: 2022, month: 6, week: 5 }
   * ```
   * @see {@link https://en.wikipedia.org/wiki/ISO_week_date ISO 8601}
   */
  export function toISOWeekOfMonth(time: ConfigType): ToISOWeekOfMonth;
}

/**
 * @see {@link https://day.js.org/docs/en/plugin/plugin Dayjs plugin}
 */
const isoWeekOfMonthPlugin: PluginFunc = (_option, _dayjsClass, dayjsFactory) => {
  dayjsFactory.toISOWeekOfMonth = function (time) {
    return new WeekOfMonth(time).toISOWeekOfMonth();
  };
};

export default isoWeekOfMonthPlugin;
